import React, { useState } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import ApiHost from "../../ApiHost";

const QuestionForm = ({ show, showQuestionKey, handleQuestionFormClose }) => {
  const [formData, setFormData] = useState({
    comments: "",
    email: "",
    first_name: "",
    last_name: "",
    phone: "",
    consent: false
  });

  const resetForm = () => {
    setFormData({
      comments: "",
      email: "",
      first_name: "",
      last_name: "",
      phone: "",
      consent: false
    });
  };

  const [questionLoading, setQuestionLoading] = useState(false);
  
  const handleQuestionClose = () => {
    handleQuestionFormClose();
    setQuestionLoading(false);
  };

  const handleChange = (e) => {
    const { id, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    setQuestionLoading(true);
    e.preventDefault();

    try {
      const response = await fetch(`${ApiHost}/v1/submit-question-form`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({...formData,question_key: showQuestionKey}),
      });
  
      if (!response.ok) throw new Error('Failed to submit question');

      handleQuestionClose();
      resetForm();
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <Modal show={show} onHide={handleQuestionClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>How can we help you?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="comments">
            <Form.Control
              as="textarea"
              rows={3}
              required
              placeholder="Please ask anything"
              value={formData.comments}
              onChange={handleChange}
            />
          </Form.Group>
          <br />
          <Form.Group controlId="email">
            <Form.Control
              type="email"
              required
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
            />
          </Form.Group>
          <br />
          <Form.Group controlId="first_name">
            <Form.Control
              type="text"
              required
              placeholder="First name"
              value={formData.first_name}
              onChange={handleChange}
            />
          </Form.Group>
          <br />
          <Form.Group controlId="last_name">
            <Form.Control
              type="text"
              placeholder="Last name"
              value={formData.last_name}
              onChange={handleChange}
            />
          </Form.Group>
          <br />
          <Form.Group controlId="phone">
            <Form.Control
              type="tel"
              placeholder="Enter your phone number"
              value={formData.phone}
              onChange={handleChange}
            />
          </Form.Group>
          <br />
          <Form.Group controlId="consent">
            <Form.Check
              type="checkbox"
              label="I consent to using my details to create a DriverHQ profile."
              checked={formData.consent}
              onChange={handleChange}
              required
            />
            <br />
            <p>
              For further details, please refer to our{" "}
              <a onClick={handleQuestionClose} href="#Privacy">Privacy Policy</a>.
            </p>
          </Form.Group>
          <Button variant="warning" type="submit" style={{ width: "100%" }} disabled={questionLoading}>
                    {questionLoading ? (
                        <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                        />
                    ) : (
                        'Submit'
                    )}
                </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default QuestionForm;
